export const _en = {
    create: {
        footerBtns: {
            ok: {
                label: "Edit"
            },
            close: {
                label: "Annuler"
            }
        }
    },
    update: {
        footerBtns: {
            ok: {
                label: "Update"
            },
            close: {
                label: "Cancel"
            }
        }
    },
    duplicate: {
        footerBtns: {
            ok: {
                label: "Duplicate"
            },
            close: {
                label: "Cancel"
            }
        }
    },
    selection: {
        footerBtns: {
            ok: {
                label: "Valid"
            },
            close: {
                label: "Close"
            }
        }
    }
};

export const _fr = {
    create: {
        footerBtns: {
            ok: {
                label: "Ajouter"
            },
            close: {
                label: "Annuler"
            }
        }
    },
    update: {
        footerBtns: {
            ok: {
                label: "Éditer"
            },
            close: {
                label: "Annuler"
            }
        }
    },
    duplicate: {
        footerBtns: {
            ok: {
                label: "Dupliquer"
            },
            close: {
                label: "Annuler"
            }
        }
    },
    deletion: {
        delete: {
            title: "Vous allez supprimer : "
        },
        unarchive: {
            title: "Vous allez désarchiver : "
        },
        both: {
            title: "Vous allez supprimer / désarchiver : "
        },
        footerBtns: {
            delete: "Supprimer",
            unarchive: "Désarchiver",
            both: "Confirmer"
        }
    },
    selection: {
        footerBtns: {
            ok: {
                label: "Valider"
            },
            close: {
                label: "Fermer"
            }
        }
    }
};